// This file is auto-generated by @hey-api/openapi-ts

import { type Options, authLogin, authLoginGoogle, authGetCurrentUser, authGetUserProfile, authLinkGoogle, authSetEmail, authDismissEmailPrompt, updateUserSettings, updateUserVerification, requestProfilePictureUpload, confirmProfilePictureUpload, deleteProfilePicture, getProfilePictureUrl, listMatches, createMatch, getChampionTiers, getMatch, deleteWikiPage, getWikiPageById, updateWikiPage, getAllWikiPages, createWikiPage, publishWikiPage, unpublishWikiPage, listKnowledgePosts, createKnowledgePost, deleteKnowledgePost, getKnowledgePost, updateKnowledgePost, toggleKnowledgePostLike, toggleSaveKnowledgePost, getSavedKnowledgePosts, listMyKnowledgePosts, listKnowledgeComments, createKnowledgeComment, createKnowledgeReply, listGamePatches, deletePinnedCombo, getPinnedCombo, pinCombo, listUserCombos, createUserCombo, deleteUserCombo, getUserCombo, updateUserCombo, promoteComboToPost, createShareCode, resolveShareCode, getAllPatchNotes, getLatestPatchNote, getUserNotifications, getUnreadCount, markNotificationAsRead, markAllNotificationsAsRead, requestWikiImageUpload, getWikiImageViewUrl, getAllChampions, adminLogin, adminGetCurrentUser, adminChangePassword, adminGetAllAdmins, adminCreateAdmin, adminUpdateAdminAccessLevel, adminResetAdminPassword, adminDeleteAdmin, adminGetOverviewStats, adminGetUserGrowth, adminGetUserRetention, adminGetMatchVolume, adminGetGameModeDistribution, adminGetContentEngagement, adminGetComboUsage, adminListGamePatches, adminCreateGamePatch, adminDeleteGamePatch, adminGetGamePatch, adminUpdateGamePatch, adminGetOverwolfDau, adminGetOverwolfInstalls, adminGetOverwolfDailyRevenue, adminGetOverwolfMtdRevenue, adminGetOverwolfMonthly, adminGetAllNews, adminCreateNews, adminDeleteNews, adminGetNewsById, adminUpdateNews, getVisibleNews, getVisibleNewsById, getActiveGames, getActiveGameById, adminGetAllChampions, adminCreateChampion, adminDeactivateChampion, adminGetChampionById, adminUpdateChampion, adminRequestChampionImageUpload, adminGetAllCampaigns, adminCreateCampaign, adminGetCampaignStats, adminGetCampaignTimeSeries, adminDeleteCampaign, adminGetCampaign, adminUpdateCampaign, adminGetCampaignEmailTemplates, adminGetCampaignEmailAudience, adminSendCampaignEmail, adminGetCampaignEmailHistory, resolveCampaignReferral, adminGetAllAffiliates, adminCreateAffiliate, adminGetAffiliateEarnings, adminDeleteAffiliate, adminGetAffiliate, adminUpdateAffiliate, getCounterState, adminGetCounter, adminUpdateCounter, adminGetAllPickemEvents, adminCreatePickemEvent, adminDeletePickemEvent, adminGetPickemEventById, adminUpdatePickemEvent, adminAddPickemCompetitor, adminRemovePickemCompetitor, adminUpdatePickemCompetitor, adminGeneratePickemBracket, adminUpdateBracketMatchResult, adminPlaceBracketCompetitor, adminGetPickemLeaderboard, adminRequestPickemImageUpload, adminSettlePickemRewards, getPickemEvents, getPickemEventDetail, getPickemLeaderboard, submitPickemPicks, getPickemUserBracket, getPickemUserScore, requestPickemShareImageUpload, getPickemSharePreview, getPickemShortShare, adminGetAllRewards, adminCreateReward, adminDisableReward, adminGetRewardById, adminUpdateReward, adminEnableReward, adminGetAllRewardBoxes, adminCreateRewardBox, adminDisableRewardBox, adminGetRewardBoxById, adminUpdateRewardBox, adminEnableRewardBox, adminAddRewardBoxItem, adminRemoveRewardBoxItem, adminUpdateRewardBoxItem, adminListUserBalances, adminGetUserBalanceSummary, adminGetUserXpHistory, adminGetUserTokenHistory, adminCreditUserXp, adminCreditUserTokens, adminSpendUserTokens, getMyBalance, getMyBadges, getMyBoxes, openMyBox, adminGetAllEarnRules, adminCreateEarnRule, adminGetEarnRuleById, adminUpdateEarnRule, adminEnableEarnRule, adminDisableEarnRule, adminGetBountyRules, adminGetCampaignEarnings, adminUpsertBountyRule, adminDeleteBountyRule, recordLogin, getMyLoginStreak, adminStartgglookup, adminStartggimport, adminStartggsets, adminStartgglink, adminStartggsync, adminStartggmetadata, adminStartggroster } from '../sdk.gen';
import { type UseMutationOptions, type DefaultError, queryOptions, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { AuthLoginData, AuthLoginResponse, AuthLoginGoogleData, AuthLoginGoogleResponse, AuthGetCurrentUserData, AuthGetUserProfileData, AuthLinkGoogleData, AuthLinkGoogleResponse, AuthSetEmailData, AuthSetEmailResponse, AuthDismissEmailPromptData, AuthDismissEmailPromptResponse, UpdateUserSettingsData, UpdateUserSettingsResponse, UpdateUserVerificationData, UpdateUserVerificationResponse, RequestProfilePictureUploadData, RequestProfilePictureUploadResponse, ConfirmProfilePictureUploadData, DeleteProfilePictureData, GetProfilePictureUrlData, ListMatchesData, ListMatchesResponse, CreateMatchData, CreateMatchResponse, GetChampionTiersData, GetMatchData, DeleteWikiPageData, DeleteWikiPageResponse2 as DeleteWikiPageResponse, GetWikiPageByIdData, UpdateWikiPageData, UpdateWikiPageResponse, GetAllWikiPagesData, CreateWikiPageData, CreateWikiPageResponse, PublishWikiPageData, PublishWikiPageResponse, UnpublishWikiPageData, UnpublishWikiPageResponse, ListKnowledgePostsData, ListKnowledgePostsResponse, CreateKnowledgePostData, CreateKnowledgePostResponse, DeleteKnowledgePostData, DeleteKnowledgePostResponse, GetKnowledgePostData, UpdateKnowledgePostData, UpdateKnowledgePostResponse, ToggleKnowledgePostLikeData, ToggleKnowledgePostLikeResponse, ToggleSaveKnowledgePostData, ToggleSaveKnowledgePostResponse, GetSavedKnowledgePostsData, GetSavedKnowledgePostsResponse, ListMyKnowledgePostsData, ListMyKnowledgePostsResponse, ListKnowledgeCommentsData, CreateKnowledgeCommentData, CreateKnowledgeCommentResponse, CreateKnowledgeReplyData, CreateKnowledgeReplyResponse, ListGamePatchesData, DeletePinnedComboData, DeletePinnedComboResponse, GetPinnedComboData, PinComboData, PinComboResponse, ListUserCombosData, CreateUserComboData, CreateUserComboResponse, DeleteUserComboData, DeleteUserComboResponse, GetUserComboData, UpdateUserComboData, UpdateUserComboResponse, PromoteComboToPostData, PromoteComboToPostResponse, CreateShareCodeData, CreateShareCodeResponse, ResolveShareCodeData, GetAllPatchNotesData, GetLatestPatchNoteData, GetUserNotificationsData, GetUserNotificationsResponse, GetUnreadCountData, MarkNotificationAsReadData, MarkNotificationAsReadResponse, MarkAllNotificationsAsReadData, MarkAllNotificationsAsReadResponse, RequestWikiImageUploadData, RequestWikiImageUploadResponse, GetWikiImageViewUrlData, GetWikiImageViewUrlResponse, GetAllChampionsData, AdminLoginData, AdminLoginResponse, AdminGetCurrentUserData, AdminChangePasswordData, AdminChangePasswordResponse2 as AdminChangePasswordResponse, AdminGetAllAdminsData, AdminCreateAdminData, AdminCreateAdminResponse, AdminUpdateAdminAccessLevelData, AdminUpdateAdminAccessLevelResponse, AdminResetAdminPasswordData, AdminResetAdminPasswordResponse, AdminDeleteAdminData, AdminDeleteAdminResponse, AdminGetOverviewStatsData, AdminGetUserGrowthData, AdminGetUserRetentionData, AdminGetMatchVolumeData, AdminGetGameModeDistributionData, AdminGetContentEngagementData, AdminGetComboUsageData, AdminListGamePatchesData, AdminCreateGamePatchData, AdminCreateGamePatchResponse, AdminDeleteGamePatchData, AdminDeleteGamePatchResponse, AdminGetGamePatchData, AdminUpdateGamePatchData, AdminUpdateGamePatchResponse, AdminGetOverwolfDauData, AdminGetOverwolfInstallsData, AdminGetOverwolfDailyRevenueData, AdminGetOverwolfMtdRevenueData, AdminGetOverwolfMonthlyData, AdminGetAllNewsData, AdminCreateNewsData, AdminCreateNewsResponse, AdminDeleteNewsData, AdminDeleteNewsResponse, AdminGetNewsByIdData, AdminUpdateNewsData, AdminUpdateNewsResponse, GetVisibleNewsData, GetVisibleNewsByIdData, GetActiveGamesData, GetActiveGameByIdData, AdminGetAllChampionsData, AdminCreateChampionData, AdminCreateChampionResponse, AdminDeactivateChampionData, AdminDeactivateChampionResponse, AdminGetChampionByIdData, AdminUpdateChampionData, AdminUpdateChampionResponse, AdminRequestChampionImageUploadData, AdminRequestChampionImageUploadResponse, AdminGetAllCampaignsData, AdminCreateCampaignData, AdminCreateCampaignResponse, AdminGetCampaignStatsData, AdminGetCampaignTimeSeriesData, AdminDeleteCampaignData, AdminDeleteCampaignResponse, AdminGetCampaignData, AdminUpdateCampaignData, AdminUpdateCampaignResponse, AdminGetCampaignEmailTemplatesData, AdminGetCampaignEmailAudienceData, AdminSendCampaignEmailData, AdminSendCampaignEmailResponse, AdminGetCampaignEmailHistoryData, ResolveCampaignReferralData, AdminGetAllAffiliatesData, AdminCreateAffiliateData, AdminCreateAffiliateResponse, AdminGetAffiliateEarningsData, AdminDeleteAffiliateData, AdminDeleteAffiliateResponse, AdminGetAffiliateData, AdminUpdateAffiliateData, AdminUpdateAffiliateResponse, GetCounterStateData, AdminGetCounterData, AdminUpdateCounterData, AdminUpdateCounterResponse, AdminGetAllPickemEventsData, AdminCreatePickemEventData, AdminCreatePickemEventResponse, AdminDeletePickemEventData, AdminDeletePickemEventResponse, AdminGetPickemEventByIdData, AdminUpdatePickemEventData, AdminUpdatePickemEventResponse, AdminAddPickemCompetitorData, AdminAddPickemCompetitorResponse, AdminRemovePickemCompetitorData, AdminRemovePickemCompetitorResponse, AdminUpdatePickemCompetitorData, AdminUpdatePickemCompetitorResponse, AdminGeneratePickemBracketData, AdminGeneratePickemBracketResponse, AdminUpdateBracketMatchResultData, AdminUpdateBracketMatchResultResponse, AdminPlaceBracketCompetitorData, AdminPlaceBracketCompetitorResponse, AdminGetPickemLeaderboardData, AdminRequestPickemImageUploadData, AdminRequestPickemImageUploadResponse, AdminSettlePickemRewardsData, AdminSettlePickemRewardsResponse, GetPickemEventsData, GetPickemEventDetailData, GetPickemLeaderboardData, SubmitPickemPicksData, SubmitPickemPicksResponse, GetPickemUserBracketData, GetPickemUserScoreData, RequestPickemShareImageUploadData, RequestPickemShareImageUploadResponse, GetPickemSharePreviewData, GetPickemShortShareData, AdminGetAllRewardsData, AdminCreateRewardData, AdminCreateRewardResponse, AdminDisableRewardData, AdminDisableRewardResponse, AdminGetRewardByIdData, AdminUpdateRewardData, AdminUpdateRewardResponse, AdminEnableRewardData, AdminEnableRewardResponse, AdminGetAllRewardBoxesData, AdminCreateRewardBoxData, AdminCreateRewardBoxResponse, AdminDisableRewardBoxData, AdminDisableRewardBoxResponse, AdminGetRewardBoxByIdData, AdminUpdateRewardBoxData, AdminUpdateRewardBoxResponse, AdminEnableRewardBoxData, AdminEnableRewardBoxResponse, AdminAddRewardBoxItemData, AdminAddRewardBoxItemResponse, AdminRemoveRewardBoxItemData, AdminRemoveRewardBoxItemResponse, AdminUpdateRewardBoxItemData, AdminUpdateRewardBoxItemResponse, AdminListUserBalancesData, AdminListUserBalancesResponse, AdminGetUserBalanceSummaryData, AdminGetUserXpHistoryData, AdminGetUserXpHistoryResponse, AdminGetUserTokenHistoryData, AdminGetUserTokenHistoryResponse, AdminCreditUserXpData, AdminCreditUserXpResponse, AdminCreditUserTokensData, AdminCreditUserTokensResponse, AdminSpendUserTokensData, AdminSpendUserTokensResponse, GetMyBalanceData, GetMyBadgesData, GetMyBoxesData, OpenMyBoxData, OpenMyBoxResponse, AdminGetAllEarnRulesData, AdminCreateEarnRuleData, AdminCreateEarnRuleResponse, AdminGetEarnRuleByIdData, AdminUpdateEarnRuleData, AdminUpdateEarnRuleResponse, AdminEnableEarnRuleData, AdminEnableEarnRuleResponse, AdminDisableEarnRuleData, AdminDisableEarnRuleResponse, AdminGetBountyRulesData, AdminGetCampaignEarningsData, AdminUpsertBountyRuleData, AdminUpsertBountyRuleResponse, AdminDeleteBountyRuleData, AdminDeleteBountyRuleResponse, RecordLoginData, RecordLoginResponse, GetMyLoginStreakData, AdminStartgglookupData, AdminStartggimportData, AdminStartggsetsData, AdminStartgglinkData, AdminStartggsyncData, AdminStartggmetadataData, AdminStartggrosterData } from '../types.gen';
import { client } from '../client.gen';

export const authLoginMutation = (options?: Partial<Options<AuthLoginData>>): UseMutationOptions<AuthLoginResponse, DefaultError, Options<AuthLoginData>> => {
    const mutationOptions: UseMutationOptions<AuthLoginResponse, DefaultError, Options<AuthLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authLoginGoogleMutation = (options?: Partial<Options<AuthLoginGoogleData>>): UseMutationOptions<AuthLoginGoogleResponse, DefaultError, Options<AuthLoginGoogleData>> => {
    const mutationOptions: UseMutationOptions<AuthLoginGoogleResponse, DefaultError, Options<AuthLoginGoogleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLoginGoogle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const authGetCurrentUserQueryKey = (options?: Options<AuthGetCurrentUserData>) => createQueryKey('authGetCurrentUser', options);

export const authGetCurrentUserOptions = (options?: Options<AuthGetCurrentUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await authGetCurrentUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authGetCurrentUserQueryKey(options)
    });
};

export const authGetUserProfileQueryKey = (options?: Options<AuthGetUserProfileData>) => createQueryKey('authGetUserProfile', options);

export const authGetUserProfileOptions = (options?: Options<AuthGetUserProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await authGetUserProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authGetUserProfileQueryKey(options)
    });
};

export const authLinkGoogleMutation = (options?: Partial<Options<AuthLinkGoogleData>>): UseMutationOptions<AuthLinkGoogleResponse, DefaultError, Options<AuthLinkGoogleData>> => {
    const mutationOptions: UseMutationOptions<AuthLinkGoogleResponse, DefaultError, Options<AuthLinkGoogleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLinkGoogle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authSetEmailMutation = (options?: Partial<Options<AuthSetEmailData>>): UseMutationOptions<AuthSetEmailResponse, DefaultError, Options<AuthSetEmailData>> => {
    const mutationOptions: UseMutationOptions<AuthSetEmailResponse, DefaultError, Options<AuthSetEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authSetEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authDismissEmailPromptMutation = (options?: Partial<Options<AuthDismissEmailPromptData>>): UseMutationOptions<AuthDismissEmailPromptResponse, DefaultError, Options<AuthDismissEmailPromptData>> => {
    const mutationOptions: UseMutationOptions<AuthDismissEmailPromptResponse, DefaultError, Options<AuthDismissEmailPromptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authDismissEmailPrompt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateUserSettingsMutation = (options?: Partial<Options<UpdateUserSettingsData>>): UseMutationOptions<UpdateUserSettingsResponse, DefaultError, Options<UpdateUserSettingsData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserSettingsResponse, DefaultError, Options<UpdateUserSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateUserVerificationMutation = (options?: Partial<Options<UpdateUserVerificationData>>): UseMutationOptions<UpdateUserVerificationResponse, DefaultError, Options<UpdateUserVerificationData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserVerificationResponse, DefaultError, Options<UpdateUserVerificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserVerification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const requestProfilePictureUploadMutation = (options?: Partial<Options<RequestProfilePictureUploadData>>): UseMutationOptions<RequestProfilePictureUploadResponse, DefaultError, Options<RequestProfilePictureUploadData>> => {
    const mutationOptions: UseMutationOptions<RequestProfilePictureUploadResponse, DefaultError, Options<RequestProfilePictureUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestProfilePictureUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const confirmProfilePictureUploadMutation = (options?: Partial<Options<ConfirmProfilePictureUploadData>>): UseMutationOptions<unknown, DefaultError, Options<ConfirmProfilePictureUploadData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ConfirmProfilePictureUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmProfilePictureUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteProfilePictureMutation = (options?: Partial<Options<DeleteProfilePictureData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteProfilePictureData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteProfilePictureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProfilePicture({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProfilePictureUrlQueryKey = (options: Options<GetProfilePictureUrlData>) => createQueryKey('getProfilePictureUrl', options);

export const getProfilePictureUrlOptions = (options: Options<GetProfilePictureUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProfilePictureUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProfilePictureUrlQueryKey(options)
    });
};

export const listMatchesQueryKey = (options?: Options<ListMatchesData>) => createQueryKey('listMatches', options);

export const listMatchesOptions = (options?: Options<ListMatchesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listMatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMatchesQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listMatchesInfiniteQueryKey = (options?: Options<ListMatchesData>): QueryKey<Options<ListMatchesData>> => createQueryKey('listMatches', options, true);

export const listMatchesInfiniteOptions = (options?: Options<ListMatchesData>) => {
    return infiniteQueryOptions<ListMatchesResponse, DefaultError, InfiniteData<ListMatchesResponse>, QueryKey<Options<ListMatchesData>>, number | Pick<QueryKey<Options<ListMatchesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListMatchesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listMatches({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMatchesInfiniteQueryKey(options)
    });
};

export const createMatchMutation = (options?: Partial<Options<CreateMatchData>>): UseMutationOptions<CreateMatchResponse, DefaultError, Options<CreateMatchData>> => {
    const mutationOptions: UseMutationOptions<CreateMatchResponse, DefaultError, Options<CreateMatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getChampionTiersQueryKey = (options?: Options<GetChampionTiersData>) => createQueryKey('getChampionTiers', options);

export const getChampionTiersOptions = (options?: Options<GetChampionTiersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getChampionTiers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getChampionTiersQueryKey(options)
    });
};

export const getMatchQueryKey = (options: Options<GetMatchData>) => createQueryKey('getMatch', options);

export const getMatchOptions = (options: Options<GetMatchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMatchQueryKey(options)
    });
};

export const deleteWikiPageMutation = (options?: Partial<Options<DeleteWikiPageData>>): UseMutationOptions<DeleteWikiPageResponse, DefaultError, Options<DeleteWikiPageData>> => {
    const mutationOptions: UseMutationOptions<DeleteWikiPageResponse, DefaultError, Options<DeleteWikiPageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteWikiPage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWikiPageByIdQueryKey = (options: Options<GetWikiPageByIdData>) => createQueryKey('getWikiPageById', options);

export const getWikiPageByIdOptions = (options: Options<GetWikiPageByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWikiPageById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWikiPageByIdQueryKey(options)
    });
};

export const updateWikiPageMutation = (options?: Partial<Options<UpdateWikiPageData>>): UseMutationOptions<UpdateWikiPageResponse, DefaultError, Options<UpdateWikiPageData>> => {
    const mutationOptions: UseMutationOptions<UpdateWikiPageResponse, DefaultError, Options<UpdateWikiPageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWikiPage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllWikiPagesQueryKey = (options?: Options<GetAllWikiPagesData>) => createQueryKey('getAllWikiPages', options);

export const getAllWikiPagesOptions = (options?: Options<GetAllWikiPagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllWikiPages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllWikiPagesQueryKey(options)
    });
};

export const createWikiPageMutation = (options?: Partial<Options<CreateWikiPageData>>): UseMutationOptions<CreateWikiPageResponse, DefaultError, Options<CreateWikiPageData>> => {
    const mutationOptions: UseMutationOptions<CreateWikiPageResponse, DefaultError, Options<CreateWikiPageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWikiPage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publishWikiPageMutation = (options?: Partial<Options<PublishWikiPageData>>): UseMutationOptions<PublishWikiPageResponse, DefaultError, Options<PublishWikiPageData>> => {
    const mutationOptions: UseMutationOptions<PublishWikiPageResponse, DefaultError, Options<PublishWikiPageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishWikiPage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const unpublishWikiPageMutation = (options?: Partial<Options<UnpublishWikiPageData>>): UseMutationOptions<UnpublishWikiPageResponse, DefaultError, Options<UnpublishWikiPageData>> => {
    const mutationOptions: UseMutationOptions<UnpublishWikiPageResponse, DefaultError, Options<UnpublishWikiPageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unpublishWikiPage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listKnowledgePostsQueryKey = (options?: Options<ListKnowledgePostsData>) => createQueryKey('listKnowledgePosts', options);

export const listKnowledgePostsOptions = (options?: Options<ListKnowledgePostsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listKnowledgePosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listKnowledgePostsQueryKey(options)
    });
};

export const listKnowledgePostsInfiniteQueryKey = (options?: Options<ListKnowledgePostsData>): QueryKey<Options<ListKnowledgePostsData>> => createQueryKey('listKnowledgePosts', options, true);

export const listKnowledgePostsInfiniteOptions = (options?: Options<ListKnowledgePostsData>) => {
    return infiniteQueryOptions<ListKnowledgePostsResponse, DefaultError, InfiniteData<ListKnowledgePostsResponse>, QueryKey<Options<ListKnowledgePostsData>>, number | Pick<QueryKey<Options<ListKnowledgePostsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListKnowledgePostsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listKnowledgePosts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listKnowledgePostsInfiniteQueryKey(options)
    });
};

export const createKnowledgePostMutation = (options?: Partial<Options<CreateKnowledgePostData>>): UseMutationOptions<CreateKnowledgePostResponse, DefaultError, Options<CreateKnowledgePostData>> => {
    const mutationOptions: UseMutationOptions<CreateKnowledgePostResponse, DefaultError, Options<CreateKnowledgePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createKnowledgePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteKnowledgePostMutation = (options?: Partial<Options<DeleteKnowledgePostData>>): UseMutationOptions<DeleteKnowledgePostResponse, DefaultError, Options<DeleteKnowledgePostData>> => {
    const mutationOptions: UseMutationOptions<DeleteKnowledgePostResponse, DefaultError, Options<DeleteKnowledgePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteKnowledgePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getKnowledgePostQueryKey = (options: Options<GetKnowledgePostData>) => createQueryKey('getKnowledgePost', options);

export const getKnowledgePostOptions = (options: Options<GetKnowledgePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getKnowledgePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getKnowledgePostQueryKey(options)
    });
};

export const updateKnowledgePostMutation = (options?: Partial<Options<UpdateKnowledgePostData>>): UseMutationOptions<UpdateKnowledgePostResponse, DefaultError, Options<UpdateKnowledgePostData>> => {
    const mutationOptions: UseMutationOptions<UpdateKnowledgePostResponse, DefaultError, Options<UpdateKnowledgePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateKnowledgePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const toggleKnowledgePostLikeMutation = (options?: Partial<Options<ToggleKnowledgePostLikeData>>): UseMutationOptions<ToggleKnowledgePostLikeResponse, DefaultError, Options<ToggleKnowledgePostLikeData>> => {
    const mutationOptions: UseMutationOptions<ToggleKnowledgePostLikeResponse, DefaultError, Options<ToggleKnowledgePostLikeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await toggleKnowledgePostLike({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const toggleSaveKnowledgePostMutation = (options?: Partial<Options<ToggleSaveKnowledgePostData>>): UseMutationOptions<ToggleSaveKnowledgePostResponse, DefaultError, Options<ToggleSaveKnowledgePostData>> => {
    const mutationOptions: UseMutationOptions<ToggleSaveKnowledgePostResponse, DefaultError, Options<ToggleSaveKnowledgePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await toggleSaveKnowledgePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSavedKnowledgePostsQueryKey = (options?: Options<GetSavedKnowledgePostsData>) => createQueryKey('getSavedKnowledgePosts', options);

export const getSavedKnowledgePostsOptions = (options?: Options<GetSavedKnowledgePostsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSavedKnowledgePosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSavedKnowledgePostsQueryKey(options)
    });
};

export const getSavedKnowledgePostsInfiniteQueryKey = (options?: Options<GetSavedKnowledgePostsData>): QueryKey<Options<GetSavedKnowledgePostsData>> => createQueryKey('getSavedKnowledgePosts', options, true);

export const getSavedKnowledgePostsInfiniteOptions = (options?: Options<GetSavedKnowledgePostsData>) => {
    return infiniteQueryOptions<GetSavedKnowledgePostsResponse, DefaultError, InfiniteData<GetSavedKnowledgePostsResponse>, QueryKey<Options<GetSavedKnowledgePostsData>>, number | Pick<QueryKey<Options<GetSavedKnowledgePostsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetSavedKnowledgePostsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getSavedKnowledgePosts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSavedKnowledgePostsInfiniteQueryKey(options)
    });
};

export const listMyKnowledgePostsQueryKey = (options?: Options<ListMyKnowledgePostsData>) => createQueryKey('listMyKnowledgePosts', options);

export const listMyKnowledgePostsOptions = (options?: Options<ListMyKnowledgePostsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listMyKnowledgePosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMyKnowledgePostsQueryKey(options)
    });
};

export const listMyKnowledgePostsInfiniteQueryKey = (options?: Options<ListMyKnowledgePostsData>): QueryKey<Options<ListMyKnowledgePostsData>> => createQueryKey('listMyKnowledgePosts', options, true);

export const listMyKnowledgePostsInfiniteOptions = (options?: Options<ListMyKnowledgePostsData>) => {
    return infiniteQueryOptions<ListMyKnowledgePostsResponse, DefaultError, InfiniteData<ListMyKnowledgePostsResponse>, QueryKey<Options<ListMyKnowledgePostsData>>, number | Pick<QueryKey<Options<ListMyKnowledgePostsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListMyKnowledgePostsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listMyKnowledgePosts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMyKnowledgePostsInfiniteQueryKey(options)
    });
};

export const listKnowledgeCommentsQueryKey = (options: Options<ListKnowledgeCommentsData>) => createQueryKey('listKnowledgeComments', options);

export const listKnowledgeCommentsOptions = (options: Options<ListKnowledgeCommentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listKnowledgeComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listKnowledgeCommentsQueryKey(options)
    });
};

export const createKnowledgeCommentMutation = (options?: Partial<Options<CreateKnowledgeCommentData>>): UseMutationOptions<CreateKnowledgeCommentResponse, DefaultError, Options<CreateKnowledgeCommentData>> => {
    const mutationOptions: UseMutationOptions<CreateKnowledgeCommentResponse, DefaultError, Options<CreateKnowledgeCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createKnowledgeComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createKnowledgeReplyMutation = (options?: Partial<Options<CreateKnowledgeReplyData>>): UseMutationOptions<CreateKnowledgeReplyResponse, DefaultError, Options<CreateKnowledgeReplyData>> => {
    const mutationOptions: UseMutationOptions<CreateKnowledgeReplyResponse, DefaultError, Options<CreateKnowledgeReplyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createKnowledgeReply({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGamePatchesQueryKey = (options?: Options<ListGamePatchesData>) => createQueryKey('listGamePatches', options);

export const listGamePatchesOptions = (options?: Options<ListGamePatchesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listGamePatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGamePatchesQueryKey(options)
    });
};

export const deletePinnedComboMutation = (options?: Partial<Options<DeletePinnedComboData>>): UseMutationOptions<DeletePinnedComboResponse, DefaultError, Options<DeletePinnedComboData>> => {
    const mutationOptions: UseMutationOptions<DeletePinnedComboResponse, DefaultError, Options<DeletePinnedComboData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePinnedCombo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPinnedComboQueryKey = (options?: Options<GetPinnedComboData>) => createQueryKey('getPinnedCombo', options);

export const getPinnedComboOptions = (options?: Options<GetPinnedComboData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPinnedCombo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPinnedComboQueryKey(options)
    });
};

export const pinComboMutation = (options?: Partial<Options<PinComboData>>): UseMutationOptions<PinComboResponse, DefaultError, Options<PinComboData>> => {
    const mutationOptions: UseMutationOptions<PinComboResponse, DefaultError, Options<PinComboData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pinCombo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUserCombosQueryKey = (options?: Options<ListUserCombosData>) => createQueryKey('listUserCombos', options);

export const listUserCombosOptions = (options?: Options<ListUserCombosData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listUserCombos({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUserCombosQueryKey(options)
    });
};

export const createUserComboMutation = (options?: Partial<Options<CreateUserComboData>>): UseMutationOptions<CreateUserComboResponse, DefaultError, Options<CreateUserComboData>> => {
    const mutationOptions: UseMutationOptions<CreateUserComboResponse, DefaultError, Options<CreateUserComboData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUserCombo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteUserComboMutation = (options?: Partial<Options<DeleteUserComboData>>): UseMutationOptions<DeleteUserComboResponse, DefaultError, Options<DeleteUserComboData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserComboResponse, DefaultError, Options<DeleteUserComboData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUserCombo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserComboQueryKey = (options: Options<GetUserComboData>) => createQueryKey('getUserCombo', options);

export const getUserComboOptions = (options: Options<GetUserComboData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserCombo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserComboQueryKey(options)
    });
};

export const updateUserComboMutation = (options?: Partial<Options<UpdateUserComboData>>): UseMutationOptions<UpdateUserComboResponse, DefaultError, Options<UpdateUserComboData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserComboResponse, DefaultError, Options<UpdateUserComboData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserCombo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promoteComboToPostMutation = (options?: Partial<Options<PromoteComboToPostData>>): UseMutationOptions<PromoteComboToPostResponse, DefaultError, Options<PromoteComboToPostData>> => {
    const mutationOptions: UseMutationOptions<PromoteComboToPostResponse, DefaultError, Options<PromoteComboToPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promoteComboToPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createShareCodeMutation = (options?: Partial<Options<CreateShareCodeData>>): UseMutationOptions<CreateShareCodeResponse, DefaultError, Options<CreateShareCodeData>> => {
    const mutationOptions: UseMutationOptions<CreateShareCodeResponse, DefaultError, Options<CreateShareCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createShareCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveShareCodeQueryKey = (options: Options<ResolveShareCodeData>) => createQueryKey('resolveShareCode', options);

export const resolveShareCodeOptions = (options: Options<ResolveShareCodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resolveShareCode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resolveShareCodeQueryKey(options)
    });
};

export const getAllPatchNotesQueryKey = (options?: Options<GetAllPatchNotesData>) => createQueryKey('getAllPatchNotes', options);

export const getAllPatchNotesOptions = (options?: Options<GetAllPatchNotesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllPatchNotes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllPatchNotesQueryKey(options)
    });
};

export const getLatestPatchNoteQueryKey = (options?: Options<GetLatestPatchNoteData>) => createQueryKey('getLatestPatchNote', options);

export const getLatestPatchNoteOptions = (options?: Options<GetLatestPatchNoteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLatestPatchNote({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLatestPatchNoteQueryKey(options)
    });
};

export const getUserNotificationsQueryKey = (options?: Options<GetUserNotificationsData>) => createQueryKey('getUserNotifications', options);

export const getUserNotificationsOptions = (options?: Options<GetUserNotificationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserNotificationsQueryKey(options)
    });
};

export const getUserNotificationsInfiniteQueryKey = (options?: Options<GetUserNotificationsData>): QueryKey<Options<GetUserNotificationsData>> => createQueryKey('getUserNotifications', options, true);

export const getUserNotificationsInfiniteOptions = (options?: Options<GetUserNotificationsData>) => {
    return infiniteQueryOptions<GetUserNotificationsResponse, DefaultError, InfiniteData<GetUserNotificationsResponse>, QueryKey<Options<GetUserNotificationsData>>, string | Pick<QueryKey<Options<GetUserNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetUserNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getUserNotifications({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserNotificationsInfiniteQueryKey(options)
    });
};

export const getUnreadCountQueryKey = (options?: Options<GetUnreadCountData>) => createQueryKey('getUnreadCount', options);

export const getUnreadCountOptions = (options?: Options<GetUnreadCountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUnreadCount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUnreadCountQueryKey(options)
    });
};

export const markNotificationAsReadMutation = (options?: Partial<Options<MarkNotificationAsReadData>>): UseMutationOptions<MarkNotificationAsReadResponse, DefaultError, Options<MarkNotificationAsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkNotificationAsReadResponse, DefaultError, Options<MarkNotificationAsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markNotificationAsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const markAllNotificationsAsReadMutation = (options?: Partial<Options<MarkAllNotificationsAsReadData>>): UseMutationOptions<MarkAllNotificationsAsReadResponse, DefaultError, Options<MarkAllNotificationsAsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkAllNotificationsAsReadResponse, DefaultError, Options<MarkAllNotificationsAsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAllNotificationsAsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const requestWikiImageUploadMutation = (options?: Partial<Options<RequestWikiImageUploadData>>): UseMutationOptions<RequestWikiImageUploadResponse, DefaultError, Options<RequestWikiImageUploadData>> => {
    const mutationOptions: UseMutationOptions<RequestWikiImageUploadResponse, DefaultError, Options<RequestWikiImageUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestWikiImageUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWikiImageViewUrlMutation = (options?: Partial<Options<GetWikiImageViewUrlData>>): UseMutationOptions<GetWikiImageViewUrlResponse, DefaultError, Options<GetWikiImageViewUrlData>> => {
    const mutationOptions: UseMutationOptions<GetWikiImageViewUrlResponse, DefaultError, Options<GetWikiImageViewUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getWikiImageViewUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllChampionsQueryKey = (options?: Options<GetAllChampionsData>) => createQueryKey('getAllChampions', options);

export const getAllChampionsOptions = (options?: Options<GetAllChampionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllChampions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllChampionsQueryKey(options)
    });
};

export const adminLoginMutation = (options?: Partial<Options<AdminLoginData>>): UseMutationOptions<AdminLoginResponse, DefaultError, Options<AdminLoginData>> => {
    const mutationOptions: UseMutationOptions<AdminLoginResponse, DefaultError, Options<AdminLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetCurrentUserQueryKey = (options?: Options<AdminGetCurrentUserData>) => createQueryKey('adminGetCurrentUser', options);

export const adminGetCurrentUserOptions = (options?: Options<AdminGetCurrentUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCurrentUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCurrentUserQueryKey(options)
    });
};

export const adminChangePasswordMutation = (options?: Partial<Options<AdminChangePasswordData>>): UseMutationOptions<AdminChangePasswordResponse, DefaultError, Options<AdminChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<AdminChangePasswordResponse, DefaultError, Options<AdminChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminChangePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetAllAdminsQueryKey = (options?: Options<AdminGetAllAdminsData>) => createQueryKey('adminGetAllAdmins', options);

export const adminGetAllAdminsOptions = (options?: Options<AdminGetAllAdminsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllAdmins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllAdminsQueryKey(options)
    });
};

export const adminCreateAdminMutation = (options?: Partial<Options<AdminCreateAdminData>>): UseMutationOptions<AdminCreateAdminResponse, DefaultError, Options<AdminCreateAdminData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateAdminResponse, DefaultError, Options<AdminCreateAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUpdateAdminAccessLevelMutation = (options?: Partial<Options<AdminUpdateAdminAccessLevelData>>): UseMutationOptions<AdminUpdateAdminAccessLevelResponse, DefaultError, Options<AdminUpdateAdminAccessLevelData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateAdminAccessLevelResponse, DefaultError, Options<AdminUpdateAdminAccessLevelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateAdminAccessLevel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminResetAdminPasswordMutation = (options?: Partial<Options<AdminResetAdminPasswordData>>): UseMutationOptions<AdminResetAdminPasswordResponse, DefaultError, Options<AdminResetAdminPasswordData>> => {
    const mutationOptions: UseMutationOptions<AdminResetAdminPasswordResponse, DefaultError, Options<AdminResetAdminPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminResetAdminPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeleteAdminMutation = (options?: Partial<Options<AdminDeleteAdminData>>): UseMutationOptions<AdminDeleteAdminResponse, DefaultError, Options<AdminDeleteAdminData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteAdminResponse, DefaultError, Options<AdminDeleteAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetOverviewStatsQueryKey = (options?: Options<AdminGetOverviewStatsData>) => createQueryKey('adminGetOverviewStats', options);

export const adminGetOverviewStatsOptions = (options?: Options<AdminGetOverviewStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetOverviewStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetOverviewStatsQueryKey(options)
    });
};

export const adminGetUserGrowthQueryKey = (options?: Options<AdminGetUserGrowthData>) => createQueryKey('adminGetUserGrowth', options);

export const adminGetUserGrowthOptions = (options?: Options<AdminGetUserGrowthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetUserGrowth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetUserGrowthQueryKey(options)
    });
};

export const adminGetUserRetentionQueryKey = (options?: Options<AdminGetUserRetentionData>) => createQueryKey('adminGetUserRetention', options);

export const adminGetUserRetentionOptions = (options?: Options<AdminGetUserRetentionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetUserRetention({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetUserRetentionQueryKey(options)
    });
};

export const adminGetMatchVolumeQueryKey = (options?: Options<AdminGetMatchVolumeData>) => createQueryKey('adminGetMatchVolume', options);

export const adminGetMatchVolumeOptions = (options?: Options<AdminGetMatchVolumeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetMatchVolume({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetMatchVolumeQueryKey(options)
    });
};

export const adminGetGameModeDistributionQueryKey = (options?: Options<AdminGetGameModeDistributionData>) => createQueryKey('adminGetGameModeDistribution', options);

export const adminGetGameModeDistributionOptions = (options?: Options<AdminGetGameModeDistributionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetGameModeDistribution({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetGameModeDistributionQueryKey(options)
    });
};

export const adminGetContentEngagementQueryKey = (options?: Options<AdminGetContentEngagementData>) => createQueryKey('adminGetContentEngagement', options);

export const adminGetContentEngagementOptions = (options?: Options<AdminGetContentEngagementData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetContentEngagement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetContentEngagementQueryKey(options)
    });
};

export const adminGetComboUsageQueryKey = (options?: Options<AdminGetComboUsageData>) => createQueryKey('adminGetComboUsage', options);

export const adminGetComboUsageOptions = (options?: Options<AdminGetComboUsageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetComboUsage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetComboUsageQueryKey(options)
    });
};

export const adminListGamePatchesQueryKey = (options?: Options<AdminListGamePatchesData>) => createQueryKey('adminListGamePatches', options);

export const adminListGamePatchesOptions = (options?: Options<AdminListGamePatchesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminListGamePatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListGamePatchesQueryKey(options)
    });
};

export const adminCreateGamePatchMutation = (options?: Partial<Options<AdminCreateGamePatchData>>): UseMutationOptions<AdminCreateGamePatchResponse, DefaultError, Options<AdminCreateGamePatchData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateGamePatchResponse, DefaultError, Options<AdminCreateGamePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateGamePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeleteGamePatchMutation = (options?: Partial<Options<AdminDeleteGamePatchData>>): UseMutationOptions<AdminDeleteGamePatchResponse, DefaultError, Options<AdminDeleteGamePatchData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteGamePatchResponse, DefaultError, Options<AdminDeleteGamePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteGamePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetGamePatchQueryKey = (options: Options<AdminGetGamePatchData>) => createQueryKey('adminGetGamePatch', options);

export const adminGetGamePatchOptions = (options: Options<AdminGetGamePatchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetGamePatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetGamePatchQueryKey(options)
    });
};

export const adminUpdateGamePatchMutation = (options?: Partial<Options<AdminUpdateGamePatchData>>): UseMutationOptions<AdminUpdateGamePatchResponse, DefaultError, Options<AdminUpdateGamePatchData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateGamePatchResponse, DefaultError, Options<AdminUpdateGamePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateGamePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetOverwolfDauQueryKey = (options?: Options<AdminGetOverwolfDauData>) => createQueryKey('adminGetOverwolfDau', options);

export const adminGetOverwolfDauOptions = (options?: Options<AdminGetOverwolfDauData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetOverwolfDau({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetOverwolfDauQueryKey(options)
    });
};

export const adminGetOverwolfInstallsQueryKey = (options?: Options<AdminGetOverwolfInstallsData>) => createQueryKey('adminGetOverwolfInstalls', options);

export const adminGetOverwolfInstallsOptions = (options?: Options<AdminGetOverwolfInstallsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetOverwolfInstalls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetOverwolfInstallsQueryKey(options)
    });
};

export const adminGetOverwolfDailyRevenueQueryKey = (options?: Options<AdminGetOverwolfDailyRevenueData>) => createQueryKey('adminGetOverwolfDailyRevenue', options);

export const adminGetOverwolfDailyRevenueOptions = (options?: Options<AdminGetOverwolfDailyRevenueData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetOverwolfDailyRevenue({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetOverwolfDailyRevenueQueryKey(options)
    });
};

export const adminGetOverwolfMtdRevenueQueryKey = (options?: Options<AdminGetOverwolfMtdRevenueData>) => createQueryKey('adminGetOverwolfMtdRevenue', options);

export const adminGetOverwolfMtdRevenueOptions = (options?: Options<AdminGetOverwolfMtdRevenueData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetOverwolfMtdRevenue({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetOverwolfMtdRevenueQueryKey(options)
    });
};

export const adminGetOverwolfMonthlyQueryKey = (options?: Options<AdminGetOverwolfMonthlyData>) => createQueryKey('adminGetOverwolfMonthly', options);

export const adminGetOverwolfMonthlyOptions = (options?: Options<AdminGetOverwolfMonthlyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetOverwolfMonthly({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetOverwolfMonthlyQueryKey(options)
    });
};

export const adminGetAllNewsQueryKey = (options?: Options<AdminGetAllNewsData>) => createQueryKey('adminGetAllNews', options);

export const adminGetAllNewsOptions = (options?: Options<AdminGetAllNewsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllNews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllNewsQueryKey(options)
    });
};

export const adminCreateNewsMutation = (options?: Partial<Options<AdminCreateNewsData>>): UseMutationOptions<AdminCreateNewsResponse, DefaultError, Options<AdminCreateNewsData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateNewsResponse, DefaultError, Options<AdminCreateNewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateNews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeleteNewsMutation = (options?: Partial<Options<AdminDeleteNewsData>>): UseMutationOptions<AdminDeleteNewsResponse, DefaultError, Options<AdminDeleteNewsData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteNewsResponse, DefaultError, Options<AdminDeleteNewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteNews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetNewsByIdQueryKey = (options: Options<AdminGetNewsByIdData>) => createQueryKey('adminGetNewsById', options);

export const adminGetNewsByIdOptions = (options: Options<AdminGetNewsByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetNewsById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetNewsByIdQueryKey(options)
    });
};

export const adminUpdateNewsMutation = (options?: Partial<Options<AdminUpdateNewsData>>): UseMutationOptions<AdminUpdateNewsResponse, DefaultError, Options<AdminUpdateNewsData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateNewsResponse, DefaultError, Options<AdminUpdateNewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateNews({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getVisibleNewsQueryKey = (options?: Options<GetVisibleNewsData>) => createQueryKey('getVisibleNews', options);

export const getVisibleNewsOptions = (options?: Options<GetVisibleNewsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getVisibleNews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getVisibleNewsQueryKey(options)
    });
};

export const getVisibleNewsByIdQueryKey = (options: Options<GetVisibleNewsByIdData>) => createQueryKey('getVisibleNewsById', options);

export const getVisibleNewsByIdOptions = (options: Options<GetVisibleNewsByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getVisibleNewsById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getVisibleNewsByIdQueryKey(options)
    });
};

export const getActiveGamesQueryKey = (options?: Options<GetActiveGamesData>) => createQueryKey('getActiveGames', options);

export const getActiveGamesOptions = (options?: Options<GetActiveGamesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getActiveGames({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getActiveGamesQueryKey(options)
    });
};

export const getActiveGameByIdQueryKey = (options: Options<GetActiveGameByIdData>) => createQueryKey('getActiveGameById', options);

export const getActiveGameByIdOptions = (options: Options<GetActiveGameByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getActiveGameById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getActiveGameByIdQueryKey(options)
    });
};

export const adminGetAllChampionsQueryKey = (options?: Options<AdminGetAllChampionsData>) => createQueryKey('adminGetAllChampions', options);

export const adminGetAllChampionsOptions = (options?: Options<AdminGetAllChampionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllChampions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllChampionsQueryKey(options)
    });
};

export const adminCreateChampionMutation = (options?: Partial<Options<AdminCreateChampionData>>): UseMutationOptions<AdminCreateChampionResponse, DefaultError, Options<AdminCreateChampionData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateChampionResponse, DefaultError, Options<AdminCreateChampionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateChampion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeactivateChampionMutation = (options?: Partial<Options<AdminDeactivateChampionData>>): UseMutationOptions<AdminDeactivateChampionResponse, DefaultError, Options<AdminDeactivateChampionData>> => {
    const mutationOptions: UseMutationOptions<AdminDeactivateChampionResponse, DefaultError, Options<AdminDeactivateChampionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeactivateChampion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetChampionByIdQueryKey = (options: Options<AdminGetChampionByIdData>) => createQueryKey('adminGetChampionById', options);

export const adminGetChampionByIdOptions = (options: Options<AdminGetChampionByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetChampionById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetChampionByIdQueryKey(options)
    });
};

export const adminUpdateChampionMutation = (options?: Partial<Options<AdminUpdateChampionData>>): UseMutationOptions<AdminUpdateChampionResponse, DefaultError, Options<AdminUpdateChampionData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateChampionResponse, DefaultError, Options<AdminUpdateChampionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateChampion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminRequestChampionImageUploadMutation = (options?: Partial<Options<AdminRequestChampionImageUploadData>>): UseMutationOptions<AdminRequestChampionImageUploadResponse, DefaultError, Options<AdminRequestChampionImageUploadData>> => {
    const mutationOptions: UseMutationOptions<AdminRequestChampionImageUploadResponse, DefaultError, Options<AdminRequestChampionImageUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRequestChampionImageUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetAllCampaignsQueryKey = (options?: Options<AdminGetAllCampaignsData>) => createQueryKey('adminGetAllCampaigns', options);

export const adminGetAllCampaignsOptions = (options?: Options<AdminGetAllCampaignsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllCampaigns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllCampaignsQueryKey(options)
    });
};

export const adminCreateCampaignMutation = (options?: Partial<Options<AdminCreateCampaignData>>): UseMutationOptions<AdminCreateCampaignResponse, DefaultError, Options<AdminCreateCampaignData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateCampaignResponse, DefaultError, Options<AdminCreateCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetCampaignStatsQueryKey = (options?: Options<AdminGetCampaignStatsData>) => createQueryKey('adminGetCampaignStats', options);

export const adminGetCampaignStatsOptions = (options?: Options<AdminGetCampaignStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCampaignStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCampaignStatsQueryKey(options)
    });
};

export const adminGetCampaignTimeSeriesQueryKey = (options: Options<AdminGetCampaignTimeSeriesData>) => createQueryKey('adminGetCampaignTimeSeries', options);

export const adminGetCampaignTimeSeriesOptions = (options: Options<AdminGetCampaignTimeSeriesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCampaignTimeSeries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCampaignTimeSeriesQueryKey(options)
    });
};

export const adminDeleteCampaignMutation = (options?: Partial<Options<AdminDeleteCampaignData>>): UseMutationOptions<AdminDeleteCampaignResponse, DefaultError, Options<AdminDeleteCampaignData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteCampaignResponse, DefaultError, Options<AdminDeleteCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetCampaignQueryKey = (options: Options<AdminGetCampaignData>) => createQueryKey('adminGetCampaign', options);

export const adminGetCampaignOptions = (options: Options<AdminGetCampaignData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCampaign({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCampaignQueryKey(options)
    });
};

export const adminUpdateCampaignMutation = (options?: Partial<Options<AdminUpdateCampaignData>>): UseMutationOptions<AdminUpdateCampaignResponse, DefaultError, Options<AdminUpdateCampaignData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateCampaignResponse, DefaultError, Options<AdminUpdateCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetCampaignEmailTemplatesQueryKey = (options?: Options<AdminGetCampaignEmailTemplatesData>) => createQueryKey('adminGetCampaignEmailTemplates', options);

export const adminGetCampaignEmailTemplatesOptions = (options?: Options<AdminGetCampaignEmailTemplatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCampaignEmailTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCampaignEmailTemplatesQueryKey(options)
    });
};

export const adminGetCampaignEmailAudienceQueryKey = (options: Options<AdminGetCampaignEmailAudienceData>) => createQueryKey('adminGetCampaignEmailAudience', options);

export const adminGetCampaignEmailAudienceOptions = (options: Options<AdminGetCampaignEmailAudienceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCampaignEmailAudience({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCampaignEmailAudienceQueryKey(options)
    });
};

export const adminSendCampaignEmailMutation = (options?: Partial<Options<AdminSendCampaignEmailData>>): UseMutationOptions<AdminSendCampaignEmailResponse, DefaultError, Options<AdminSendCampaignEmailData>> => {
    const mutationOptions: UseMutationOptions<AdminSendCampaignEmailResponse, DefaultError, Options<AdminSendCampaignEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSendCampaignEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetCampaignEmailHistoryQueryKey = (options: Options<AdminGetCampaignEmailHistoryData>) => createQueryKey('adminGetCampaignEmailHistory', options);

export const adminGetCampaignEmailHistoryOptions = (options: Options<AdminGetCampaignEmailHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCampaignEmailHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCampaignEmailHistoryQueryKey(options)
    });
};

export const resolveCampaignReferralQueryKey = (options: Options<ResolveCampaignReferralData>) => createQueryKey('resolveCampaignReferral', options);

export const resolveCampaignReferralOptions = (options: Options<ResolveCampaignReferralData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resolveCampaignReferral({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resolveCampaignReferralQueryKey(options)
    });
};

export const adminGetAllAffiliatesQueryKey = (options?: Options<AdminGetAllAffiliatesData>) => createQueryKey('adminGetAllAffiliates', options);

export const adminGetAllAffiliatesOptions = (options?: Options<AdminGetAllAffiliatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllAffiliates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllAffiliatesQueryKey(options)
    });
};

export const adminCreateAffiliateMutation = (options?: Partial<Options<AdminCreateAffiliateData>>): UseMutationOptions<AdminCreateAffiliateResponse, DefaultError, Options<AdminCreateAffiliateData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateAffiliateResponse, DefaultError, Options<AdminCreateAffiliateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateAffiliate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetAffiliateEarningsQueryKey = (options: Options<AdminGetAffiliateEarningsData>) => createQueryKey('adminGetAffiliateEarnings', options);

export const adminGetAffiliateEarningsOptions = (options: Options<AdminGetAffiliateEarningsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAffiliateEarnings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAffiliateEarningsQueryKey(options)
    });
};

export const adminDeleteAffiliateMutation = (options?: Partial<Options<AdminDeleteAffiliateData>>): UseMutationOptions<AdminDeleteAffiliateResponse, DefaultError, Options<AdminDeleteAffiliateData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteAffiliateResponse, DefaultError, Options<AdminDeleteAffiliateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteAffiliate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetAffiliateQueryKey = (options: Options<AdminGetAffiliateData>) => createQueryKey('adminGetAffiliate', options);

export const adminGetAffiliateOptions = (options: Options<AdminGetAffiliateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAffiliate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAffiliateQueryKey(options)
    });
};

export const adminUpdateAffiliateMutation = (options?: Partial<Options<AdminUpdateAffiliateData>>): UseMutationOptions<AdminUpdateAffiliateResponse, DefaultError, Options<AdminUpdateAffiliateData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateAffiliateResponse, DefaultError, Options<AdminUpdateAffiliateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateAffiliate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCounterStateQueryKey = (options?: Options<GetCounterStateData>) => createQueryKey('getCounterState', options);

export const getCounterStateOptions = (options?: Options<GetCounterStateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCounterState({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCounterStateQueryKey(options)
    });
};

export const adminGetCounterQueryKey = (options?: Options<AdminGetCounterData>) => createQueryKey('adminGetCounter', options);

export const adminGetCounterOptions = (options?: Options<AdminGetCounterData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCounter({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCounterQueryKey(options)
    });
};

export const adminUpdateCounterMutation = (options?: Partial<Options<AdminUpdateCounterData>>): UseMutationOptions<AdminUpdateCounterResponse, DefaultError, Options<AdminUpdateCounterData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateCounterResponse, DefaultError, Options<AdminUpdateCounterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateCounter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetAllPickemEventsQueryKey = (options?: Options<AdminGetAllPickemEventsData>) => createQueryKey('adminGetAllPickemEvents', options);

export const adminGetAllPickemEventsOptions = (options?: Options<AdminGetAllPickemEventsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllPickemEvents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllPickemEventsQueryKey(options)
    });
};

export const adminCreatePickemEventMutation = (options?: Partial<Options<AdminCreatePickemEventData>>): UseMutationOptions<AdminCreatePickemEventResponse, DefaultError, Options<AdminCreatePickemEventData>> => {
    const mutationOptions: UseMutationOptions<AdminCreatePickemEventResponse, DefaultError, Options<AdminCreatePickemEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreatePickemEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeletePickemEventMutation = (options?: Partial<Options<AdminDeletePickemEventData>>): UseMutationOptions<AdminDeletePickemEventResponse, DefaultError, Options<AdminDeletePickemEventData>> => {
    const mutationOptions: UseMutationOptions<AdminDeletePickemEventResponse, DefaultError, Options<AdminDeletePickemEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeletePickemEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetPickemEventByIdQueryKey = (options: Options<AdminGetPickemEventByIdData>) => createQueryKey('adminGetPickemEventById', options);

export const adminGetPickemEventByIdOptions = (options: Options<AdminGetPickemEventByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetPickemEventById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetPickemEventByIdQueryKey(options)
    });
};

export const adminUpdatePickemEventMutation = (options?: Partial<Options<AdminUpdatePickemEventData>>): UseMutationOptions<AdminUpdatePickemEventResponse, DefaultError, Options<AdminUpdatePickemEventData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdatePickemEventResponse, DefaultError, Options<AdminUpdatePickemEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdatePickemEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminAddPickemCompetitorMutation = (options?: Partial<Options<AdminAddPickemCompetitorData>>): UseMutationOptions<AdminAddPickemCompetitorResponse, DefaultError, Options<AdminAddPickemCompetitorData>> => {
    const mutationOptions: UseMutationOptions<AdminAddPickemCompetitorResponse, DefaultError, Options<AdminAddPickemCompetitorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAddPickemCompetitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminRemovePickemCompetitorMutation = (options?: Partial<Options<AdminRemovePickemCompetitorData>>): UseMutationOptions<AdminRemovePickemCompetitorResponse, DefaultError, Options<AdminRemovePickemCompetitorData>> => {
    const mutationOptions: UseMutationOptions<AdminRemovePickemCompetitorResponse, DefaultError, Options<AdminRemovePickemCompetitorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRemovePickemCompetitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUpdatePickemCompetitorMutation = (options?: Partial<Options<AdminUpdatePickemCompetitorData>>): UseMutationOptions<AdminUpdatePickemCompetitorResponse, DefaultError, Options<AdminUpdatePickemCompetitorData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdatePickemCompetitorResponse, DefaultError, Options<AdminUpdatePickemCompetitorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdatePickemCompetitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGeneratePickemBracketMutation = (options?: Partial<Options<AdminGeneratePickemBracketData>>): UseMutationOptions<AdminGeneratePickemBracketResponse, DefaultError, Options<AdminGeneratePickemBracketData>> => {
    const mutationOptions: UseMutationOptions<AdminGeneratePickemBracketResponse, DefaultError, Options<AdminGeneratePickemBracketData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminGeneratePickemBracket({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUpdateBracketMatchResultMutation = (options?: Partial<Options<AdminUpdateBracketMatchResultData>>): UseMutationOptions<AdminUpdateBracketMatchResultResponse, DefaultError, Options<AdminUpdateBracketMatchResultData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateBracketMatchResultResponse, DefaultError, Options<AdminUpdateBracketMatchResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateBracketMatchResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminPlaceBracketCompetitorMutation = (options?: Partial<Options<AdminPlaceBracketCompetitorData>>): UseMutationOptions<AdminPlaceBracketCompetitorResponse, DefaultError, Options<AdminPlaceBracketCompetitorData>> => {
    const mutationOptions: UseMutationOptions<AdminPlaceBracketCompetitorResponse, DefaultError, Options<AdminPlaceBracketCompetitorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminPlaceBracketCompetitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetPickemLeaderboardQueryKey = (options: Options<AdminGetPickemLeaderboardData>) => createQueryKey('adminGetPickemLeaderboard', options);

export const adminGetPickemLeaderboardOptions = (options: Options<AdminGetPickemLeaderboardData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetPickemLeaderboard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetPickemLeaderboardQueryKey(options)
    });
};

export const adminRequestPickemImageUploadMutation = (options?: Partial<Options<AdminRequestPickemImageUploadData>>): UseMutationOptions<AdminRequestPickemImageUploadResponse, DefaultError, Options<AdminRequestPickemImageUploadData>> => {
    const mutationOptions: UseMutationOptions<AdminRequestPickemImageUploadResponse, DefaultError, Options<AdminRequestPickemImageUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRequestPickemImageUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminSettlePickemRewardsMutation = (options?: Partial<Options<AdminSettlePickemRewardsData>>): UseMutationOptions<AdminSettlePickemRewardsResponse, DefaultError, Options<AdminSettlePickemRewardsData>> => {
    const mutationOptions: UseMutationOptions<AdminSettlePickemRewardsResponse, DefaultError, Options<AdminSettlePickemRewardsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSettlePickemRewards({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPickemEventsQueryKey = (options?: Options<GetPickemEventsData>) => createQueryKey('getPickemEvents', options);

export const getPickemEventsOptions = (options?: Options<GetPickemEventsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPickemEvents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPickemEventsQueryKey(options)
    });
};

export const getPickemEventDetailQueryKey = (options: Options<GetPickemEventDetailData>) => createQueryKey('getPickemEventDetail', options);

export const getPickemEventDetailOptions = (options: Options<GetPickemEventDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPickemEventDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPickemEventDetailQueryKey(options)
    });
};

export const getPickemLeaderboardQueryKey = (options: Options<GetPickemLeaderboardData>) => createQueryKey('getPickemLeaderboard', options);

export const getPickemLeaderboardOptions = (options: Options<GetPickemLeaderboardData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPickemLeaderboard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPickemLeaderboardQueryKey(options)
    });
};

export const submitPickemPicksMutation = (options?: Partial<Options<SubmitPickemPicksData>>): UseMutationOptions<SubmitPickemPicksResponse, DefaultError, Options<SubmitPickemPicksData>> => {
    const mutationOptions: UseMutationOptions<SubmitPickemPicksResponse, DefaultError, Options<SubmitPickemPicksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitPickemPicks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPickemUserBracketQueryKey = (options: Options<GetPickemUserBracketData>) => createQueryKey('getPickemUserBracket', options);

export const getPickemUserBracketOptions = (options: Options<GetPickemUserBracketData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPickemUserBracket({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPickemUserBracketQueryKey(options)
    });
};

export const getPickemUserScoreQueryKey = (options: Options<GetPickemUserScoreData>) => createQueryKey('getPickemUserScore', options);

export const getPickemUserScoreOptions = (options: Options<GetPickemUserScoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPickemUserScore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPickemUserScoreQueryKey(options)
    });
};

export const requestPickemShareImageUploadMutation = (options?: Partial<Options<RequestPickemShareImageUploadData>>): UseMutationOptions<RequestPickemShareImageUploadResponse, DefaultError, Options<RequestPickemShareImageUploadData>> => {
    const mutationOptions: UseMutationOptions<RequestPickemShareImageUploadResponse, DefaultError, Options<RequestPickemShareImageUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestPickemShareImageUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPickemSharePreviewQueryKey = (options: Options<GetPickemSharePreviewData>) => createQueryKey('getPickemSharePreview', options);

export const getPickemSharePreviewOptions = (options: Options<GetPickemSharePreviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPickemSharePreview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPickemSharePreviewQueryKey(options)
    });
};

export const getPickemShortShareQueryKey = (options: Options<GetPickemShortShareData>) => createQueryKey('getPickemShortShare', options);

export const getPickemShortShareOptions = (options: Options<GetPickemShortShareData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPickemShortShare({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPickemShortShareQueryKey(options)
    });
};

export const adminGetAllRewardsQueryKey = (options?: Options<AdminGetAllRewardsData>) => createQueryKey('adminGetAllRewards', options);

export const adminGetAllRewardsOptions = (options?: Options<AdminGetAllRewardsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllRewards({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllRewardsQueryKey(options)
    });
};

export const adminCreateRewardMutation = (options?: Partial<Options<AdminCreateRewardData>>): UseMutationOptions<AdminCreateRewardResponse, DefaultError, Options<AdminCreateRewardData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateRewardResponse, DefaultError, Options<AdminCreateRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDisableRewardMutation = (options?: Partial<Options<AdminDisableRewardData>>): UseMutationOptions<AdminDisableRewardResponse, DefaultError, Options<AdminDisableRewardData>> => {
    const mutationOptions: UseMutationOptions<AdminDisableRewardResponse, DefaultError, Options<AdminDisableRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDisableReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetRewardByIdQueryKey = (options: Options<AdminGetRewardByIdData>) => createQueryKey('adminGetRewardById', options);

export const adminGetRewardByIdOptions = (options: Options<AdminGetRewardByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetRewardById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetRewardByIdQueryKey(options)
    });
};

export const adminUpdateRewardMutation = (options?: Partial<Options<AdminUpdateRewardData>>): UseMutationOptions<AdminUpdateRewardResponse, DefaultError, Options<AdminUpdateRewardData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateRewardResponse, DefaultError, Options<AdminUpdateRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminEnableRewardMutation = (options?: Partial<Options<AdminEnableRewardData>>): UseMutationOptions<AdminEnableRewardResponse, DefaultError, Options<AdminEnableRewardData>> => {
    const mutationOptions: UseMutationOptions<AdminEnableRewardResponse, DefaultError, Options<AdminEnableRewardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminEnableReward({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetAllRewardBoxesQueryKey = (options?: Options<AdminGetAllRewardBoxesData>) => createQueryKey('adminGetAllRewardBoxes', options);

export const adminGetAllRewardBoxesOptions = (options?: Options<AdminGetAllRewardBoxesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllRewardBoxes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllRewardBoxesQueryKey(options)
    });
};

export const adminCreateRewardBoxMutation = (options?: Partial<Options<AdminCreateRewardBoxData>>): UseMutationOptions<AdminCreateRewardBoxResponse, DefaultError, Options<AdminCreateRewardBoxData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateRewardBoxResponse, DefaultError, Options<AdminCreateRewardBoxData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateRewardBox({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDisableRewardBoxMutation = (options?: Partial<Options<AdminDisableRewardBoxData>>): UseMutationOptions<AdminDisableRewardBoxResponse, DefaultError, Options<AdminDisableRewardBoxData>> => {
    const mutationOptions: UseMutationOptions<AdminDisableRewardBoxResponse, DefaultError, Options<AdminDisableRewardBoxData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDisableRewardBox({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetRewardBoxByIdQueryKey = (options: Options<AdminGetRewardBoxByIdData>) => createQueryKey('adminGetRewardBoxById', options);

export const adminGetRewardBoxByIdOptions = (options: Options<AdminGetRewardBoxByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetRewardBoxById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetRewardBoxByIdQueryKey(options)
    });
};

export const adminUpdateRewardBoxMutation = (options?: Partial<Options<AdminUpdateRewardBoxData>>): UseMutationOptions<AdminUpdateRewardBoxResponse, DefaultError, Options<AdminUpdateRewardBoxData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateRewardBoxResponse, DefaultError, Options<AdminUpdateRewardBoxData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateRewardBox({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminEnableRewardBoxMutation = (options?: Partial<Options<AdminEnableRewardBoxData>>): UseMutationOptions<AdminEnableRewardBoxResponse, DefaultError, Options<AdminEnableRewardBoxData>> => {
    const mutationOptions: UseMutationOptions<AdminEnableRewardBoxResponse, DefaultError, Options<AdminEnableRewardBoxData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminEnableRewardBox({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminAddRewardBoxItemMutation = (options?: Partial<Options<AdminAddRewardBoxItemData>>): UseMutationOptions<AdminAddRewardBoxItemResponse, DefaultError, Options<AdminAddRewardBoxItemData>> => {
    const mutationOptions: UseMutationOptions<AdminAddRewardBoxItemResponse, DefaultError, Options<AdminAddRewardBoxItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAddRewardBoxItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminRemoveRewardBoxItemMutation = (options?: Partial<Options<AdminRemoveRewardBoxItemData>>): UseMutationOptions<AdminRemoveRewardBoxItemResponse, DefaultError, Options<AdminRemoveRewardBoxItemData>> => {
    const mutationOptions: UseMutationOptions<AdminRemoveRewardBoxItemResponse, DefaultError, Options<AdminRemoveRewardBoxItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRemoveRewardBoxItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUpdateRewardBoxItemMutation = (options?: Partial<Options<AdminUpdateRewardBoxItemData>>): UseMutationOptions<AdminUpdateRewardBoxItemResponse, DefaultError, Options<AdminUpdateRewardBoxItemData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateRewardBoxItemResponse, DefaultError, Options<AdminUpdateRewardBoxItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateRewardBoxItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListUserBalancesQueryKey = (options?: Options<AdminListUserBalancesData>) => createQueryKey('adminListUserBalances', options);

export const adminListUserBalancesOptions = (options?: Options<AdminListUserBalancesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminListUserBalances({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListUserBalancesQueryKey(options)
    });
};

export const adminListUserBalancesInfiniteQueryKey = (options?: Options<AdminListUserBalancesData>): QueryKey<Options<AdminListUserBalancesData>> => createQueryKey('adminListUserBalances', options, true);

export const adminListUserBalancesInfiniteOptions = (options?: Options<AdminListUserBalancesData>) => {
    return infiniteQueryOptions<AdminListUserBalancesResponse, DefaultError, InfiniteData<AdminListUserBalancesResponse>, QueryKey<Options<AdminListUserBalancesData>>, number | Pick<QueryKey<Options<AdminListUserBalancesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminListUserBalancesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminListUserBalances({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListUserBalancesInfiniteQueryKey(options)
    });
};

export const adminGetUserBalanceSummaryQueryKey = (options: Options<AdminGetUserBalanceSummaryData>) => createQueryKey('adminGetUserBalanceSummary', options);

export const adminGetUserBalanceSummaryOptions = (options: Options<AdminGetUserBalanceSummaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetUserBalanceSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetUserBalanceSummaryQueryKey(options)
    });
};

export const adminGetUserXpHistoryQueryKey = (options: Options<AdminGetUserXpHistoryData>) => createQueryKey('adminGetUserXpHistory', options);

export const adminGetUserXpHistoryOptions = (options: Options<AdminGetUserXpHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetUserXpHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetUserXpHistoryQueryKey(options)
    });
};

export const adminGetUserXpHistoryInfiniteQueryKey = (options: Options<AdminGetUserXpHistoryData>): QueryKey<Options<AdminGetUserXpHistoryData>> => createQueryKey('adminGetUserXpHistory', options, true);

export const adminGetUserXpHistoryInfiniteOptions = (options: Options<AdminGetUserXpHistoryData>) => {
    return infiniteQueryOptions<AdminGetUserXpHistoryResponse, DefaultError, InfiniteData<AdminGetUserXpHistoryResponse>, QueryKey<Options<AdminGetUserXpHistoryData>>, number | Pick<QueryKey<Options<AdminGetUserXpHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminGetUserXpHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminGetUserXpHistory({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetUserXpHistoryInfiniteQueryKey(options)
    });
};

export const adminGetUserTokenHistoryQueryKey = (options: Options<AdminGetUserTokenHistoryData>) => createQueryKey('adminGetUserTokenHistory', options);

export const adminGetUserTokenHistoryOptions = (options: Options<AdminGetUserTokenHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetUserTokenHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetUserTokenHistoryQueryKey(options)
    });
};

export const adminGetUserTokenHistoryInfiniteQueryKey = (options: Options<AdminGetUserTokenHistoryData>): QueryKey<Options<AdminGetUserTokenHistoryData>> => createQueryKey('adminGetUserTokenHistory', options, true);

export const adminGetUserTokenHistoryInfiniteOptions = (options: Options<AdminGetUserTokenHistoryData>) => {
    return infiniteQueryOptions<AdminGetUserTokenHistoryResponse, DefaultError, InfiniteData<AdminGetUserTokenHistoryResponse>, QueryKey<Options<AdminGetUserTokenHistoryData>>, number | Pick<QueryKey<Options<AdminGetUserTokenHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminGetUserTokenHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminGetUserTokenHistory({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetUserTokenHistoryInfiniteQueryKey(options)
    });
};

export const adminCreditUserXpMutation = (options?: Partial<Options<AdminCreditUserXpData>>): UseMutationOptions<AdminCreditUserXpResponse, DefaultError, Options<AdminCreditUserXpData>> => {
    const mutationOptions: UseMutationOptions<AdminCreditUserXpResponse, DefaultError, Options<AdminCreditUserXpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreditUserXp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCreditUserTokensMutation = (options?: Partial<Options<AdminCreditUserTokensData>>): UseMutationOptions<AdminCreditUserTokensResponse, DefaultError, Options<AdminCreditUserTokensData>> => {
    const mutationOptions: UseMutationOptions<AdminCreditUserTokensResponse, DefaultError, Options<AdminCreditUserTokensData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreditUserTokens({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminSpendUserTokensMutation = (options?: Partial<Options<AdminSpendUserTokensData>>): UseMutationOptions<AdminSpendUserTokensResponse, DefaultError, Options<AdminSpendUserTokensData>> => {
    const mutationOptions: UseMutationOptions<AdminSpendUserTokensResponse, DefaultError, Options<AdminSpendUserTokensData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSpendUserTokens({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyBalanceQueryKey = (options?: Options<GetMyBalanceData>) => createQueryKey('getMyBalance', options);

export const getMyBalanceOptions = (options?: Options<GetMyBalanceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMyBalance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMyBalanceQueryKey(options)
    });
};

export const getMyBadgesQueryKey = (options?: Options<GetMyBadgesData>) => createQueryKey('getMyBadges', options);

export const getMyBadgesOptions = (options?: Options<GetMyBadgesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMyBadges({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMyBadgesQueryKey(options)
    });
};

export const getMyBoxesQueryKey = (options?: Options<GetMyBoxesData>) => createQueryKey('getMyBoxes', options);

export const getMyBoxesOptions = (options?: Options<GetMyBoxesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMyBoxes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMyBoxesQueryKey(options)
    });
};

export const openMyBoxMutation = (options?: Partial<Options<OpenMyBoxData>>): UseMutationOptions<OpenMyBoxResponse, DefaultError, Options<OpenMyBoxData>> => {
    const mutationOptions: UseMutationOptions<OpenMyBoxResponse, DefaultError, Options<OpenMyBoxData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await openMyBox({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetAllEarnRulesQueryKey = (options?: Options<AdminGetAllEarnRulesData>) => createQueryKey('adminGetAllEarnRules', options);

export const adminGetAllEarnRulesOptions = (options?: Options<AdminGetAllEarnRulesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetAllEarnRules({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetAllEarnRulesQueryKey(options)
    });
};

export const adminCreateEarnRuleMutation = (options?: Partial<Options<AdminCreateEarnRuleData>>): UseMutationOptions<AdminCreateEarnRuleResponse, DefaultError, Options<AdminCreateEarnRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateEarnRuleResponse, DefaultError, Options<AdminCreateEarnRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateEarnRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetEarnRuleByIdQueryKey = (options: Options<AdminGetEarnRuleByIdData>) => createQueryKey('adminGetEarnRuleById', options);

export const adminGetEarnRuleByIdOptions = (options: Options<AdminGetEarnRuleByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetEarnRuleById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetEarnRuleByIdQueryKey(options)
    });
};

export const adminUpdateEarnRuleMutation = (options?: Partial<Options<AdminUpdateEarnRuleData>>): UseMutationOptions<AdminUpdateEarnRuleResponse, DefaultError, Options<AdminUpdateEarnRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateEarnRuleResponse, DefaultError, Options<AdminUpdateEarnRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateEarnRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminEnableEarnRuleMutation = (options?: Partial<Options<AdminEnableEarnRuleData>>): UseMutationOptions<AdminEnableEarnRuleResponse, DefaultError, Options<AdminEnableEarnRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminEnableEarnRuleResponse, DefaultError, Options<AdminEnableEarnRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminEnableEarnRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDisableEarnRuleMutation = (options?: Partial<Options<AdminDisableEarnRuleData>>): UseMutationOptions<AdminDisableEarnRuleResponse, DefaultError, Options<AdminDisableEarnRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminDisableEarnRuleResponse, DefaultError, Options<AdminDisableEarnRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDisableEarnRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetBountyRulesQueryKey = (options: Options<AdminGetBountyRulesData>) => createQueryKey('adminGetBountyRules', options);

export const adminGetBountyRulesOptions = (options: Options<AdminGetBountyRulesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetBountyRules({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetBountyRulesQueryKey(options)
    });
};

export const adminGetCampaignEarningsQueryKey = (options: Options<AdminGetCampaignEarningsData>) => createQueryKey('adminGetCampaignEarnings', options);

export const adminGetCampaignEarningsOptions = (options: Options<AdminGetCampaignEarningsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetCampaignEarnings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetCampaignEarningsQueryKey(options)
    });
};

export const adminUpsertBountyRuleMutation = (options?: Partial<Options<AdminUpsertBountyRuleData>>): UseMutationOptions<AdminUpsertBountyRuleResponse, DefaultError, Options<AdminUpsertBountyRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminUpsertBountyRuleResponse, DefaultError, Options<AdminUpsertBountyRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpsertBountyRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDeleteBountyRuleMutation = (options?: Partial<Options<AdminDeleteBountyRuleData>>): UseMutationOptions<AdminDeleteBountyRuleResponse, DefaultError, Options<AdminDeleteBountyRuleData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteBountyRuleResponse, DefaultError, Options<AdminDeleteBountyRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteBountyRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const recordLoginMutation = (options?: Partial<Options<RecordLoginData>>): UseMutationOptions<RecordLoginResponse, DefaultError, Options<RecordLoginData>> => {
    const mutationOptions: UseMutationOptions<RecordLoginResponse, DefaultError, Options<RecordLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyLoginStreakQueryKey = (options?: Options<GetMyLoginStreakData>) => createQueryKey('getMyLoginStreak', options);

export const getMyLoginStreakOptions = (options?: Options<GetMyLoginStreakData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMyLoginStreak({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMyLoginStreakQueryKey(options)
    });
};

export const adminStartgglookupMutation = (options?: Partial<Options<AdminStartgglookupData>>): UseMutationOptions<unknown, DefaultError, Options<AdminStartgglookupData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AdminStartgglookupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStartgglookup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStartggimportMutation = (options?: Partial<Options<AdminStartggimportData>>): UseMutationOptions<unknown, DefaultError, Options<AdminStartggimportData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AdminStartggimportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStartggimport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStartggsetsMutation = (options?: Partial<Options<AdminStartggsetsData>>): UseMutationOptions<unknown, DefaultError, Options<AdminStartggsetsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AdminStartggsetsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStartggsets({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStartgglinkMutation = (options?: Partial<Options<AdminStartgglinkData>>): UseMutationOptions<unknown, DefaultError, Options<AdminStartgglinkData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AdminStartgglinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStartgglink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStartggsyncMutation = (options?: Partial<Options<AdminStartggsyncData>>): UseMutationOptions<unknown, DefaultError, Options<AdminStartggsyncData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AdminStartggsyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStartggsync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStartggmetadataMutation = (options?: Partial<Options<AdminStartggmetadataData>>): UseMutationOptions<unknown, DefaultError, Options<AdminStartggmetadataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AdminStartggmetadataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStartggmetadata({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStartggrosterMutation = (options?: Partial<Options<AdminStartggrosterData>>): UseMutationOptions<unknown, DefaultError, Options<AdminStartggrosterData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AdminStartggrosterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStartggroster({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
